import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import projectsApi from "../../../api/requests/projectsApi";

export const fetchProjects = createAsyncThunk(
  'projects/fetchProjects',
  async (filter) => {
    return await projectsApi.fetchProjects(filter);
  }
);

export const projectsSlice = createSlice({
  name: 'projects',
  initialState: {
    projects: [],
    projectsSelect: []
  },
  reducers: {

  },
  extraReducers: {
    [fetchProjects.pending]: (state) => {
      state.isLoading = true;
    },
    [fetchProjects.fulfilled]: (state, action) => {
      state.isLoading = false;
      console.log('action', action)
      state.projects = action.payload;
      state.projectsSelect = action.payload.map(project => ({ value: project.id, label: project.id + ' - ' + project.title }));
    },
    [fetchProjects.rejected]: (state) => {
      state.isLoading = true;
    }
  }
});

export default projectsSlice.reducer;